module.exports = __webpack_public_path__ + "img/CRC1_Neutrophils.c361781c.png";